import * as React from "react"
import styled from "@emotion/styled"
import { Theme } from "gatsby-interface"
import { MdInfoOutline } from "react-icons/md"

const HelpLink = styled(`a`)`
  display: flex;

  svg {
    fill: ${p => (p.theme as Theme).colors.grey[50]};
    height: 1rem;
    width: 1rem;
  }

  :hover {
    svg {
      fill: ${p => (p.theme as Theme).colors.lilac};
    }
  }
`

export type WebhookHelpLinkProps = {
  url: string
  ariaLabel: string
}

export function WebhookHelpLink({ url, ariaLabel }: WebhookHelpLinkProps) {
  return (
    <HelpLink target="_blank" href={url} aria-label={ariaLabel}>
      <MdInfoOutline />
    </HelpLink>
  )
}
